export default __webpack_public_path__ + "static/media/gambar1.62212738.jpg";